import React, { useState, useRef, useEffect } from 'react';
import { Box } from '@mui/material';

const base = {
    overflowY: 'auto',
    '&::-webkit-scrollbar': { width: '4px' },
    '&::-webkit-scrollbar-track': { background: 'transparent' },
    '&:hover::-webkit-scrollbar-thumb': { background: 'rgba(187,188,188,0.25)' },
    '&:hover::-webkit-scrollbar-thumb:hover': { background: 'rgba(0,215,255,0.4)' },
};

function ScrollableArea({ maxHeight, sx, children }) {
    const [isScrolling, setIsScrolling] = useState(false);
    const timeoutRef = useRef(null);

    useEffect(() => () => clearTimeout(timeoutRef.current), []);

    function handleScroll() {
        setIsScrolling(true);
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => setIsScrolling(false), 1000);
    }

    return (
        <Box
            onScroll={handleScroll}
            sx={{
                ...base,
                ...sx,
                maxHeight,
                '&::-webkit-scrollbar-thumb': {
                    background: isScrolling ? 'rgba(187,188,188,0.35)' : 'transparent',
                    borderRadius: '4px',
                    transition: isScrolling ? 'background 0.1s ease' : 'background 0.6s ease',
                },
            }}
        >
            {children}
        </Box>
    );
}

export default ScrollableArea;
